import { ItemType } from '@wix/wix-vod-constants/api-types';
import { LIVE_VIDEO_STATUS } from '@wix/wix-vod-constants/common';
export const isScheduledLive = _ref => {
  let {
    itemType
  } = _ref;
  return itemType === ItemType.ItemScheduled;
};
export const isStreamingLive = _ref2 => {
  let {
    itemType
  } = _ref2;
  return itemType === ItemType.ItemLive;
};
export const isPendingLiveStream = _ref3 => {
  let {
    liveVideoStatus
  } = _ref3;
  return liveVideoStatus === LIVE_VIDEO_STATUS.PENDING;
};
export const isReadyLiveStream = _ref4 => {
  let {
    liveVideoStatus
  } = _ref4;
  return liveVideoStatus === LIVE_VIDEO_STATUS.IN_PROGRESS;
};
//# sourceMappingURL=live.js.map